// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".popover.activity-popover{min-width:25rem}.alert-delete{background-color:#f95}", ""]);
// Exports
module.exports = exports;
